import React from 'react';
import { useHistory } from 'react-router';
import RfqRequestDialogImg from './assets/RfqRequestDialogImg.png';
import { localStorage, STORAGE_ACTION } from '@utils/storage';
import { CustomizedButton, CustomizedTypography } from '@components/Customized';
import {
  Dialog,
  DialogContent,
  DialogActions,
  makeStyles,
  useTheme,
  useMediaQuery
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  paperRoot: {
    width: 476,
    borderRadius: '16px',
    padding: '56px 24px 24px 24px',
    [theme.breakpoints.down('xs')]: {
      width: 343,
      padding: '50px 16px 16px 16px'
    }
  },
  content: {
    padding: 0,
    textAlign: 'center',
    '&:first-child': {
      paddingTop: 0
    },
    '& img': {
      width: 80,
      height: 80,
      marginBottom: 40,
      [theme.breakpoints.down('xs')]: {
        marginBottom: 25
      }
    }
  },
  dialogAction: {
    padding: 0
  }
}));

interface Props {
  open: boolean;
  onClose: () => void;
}

const RfqRequestDialogPresenter: React.FC<Props> = ({ open, onClose }) => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('xs'));
  const classes = useStyles();
  const history = useHistory();

  const onClick = (path: string) => {
    onClose();
    localStorage.setItem(
      STORAGE_ACTION.REDIRECT_PATH,
      `${window.location.pathname}${window.location.search}`
    );
    history.push(path);
  };

  return (
    <Dialog
      classes={{
        paper: classes.paperRoot
      }}
      open={open}
      onClose={onClose}
    >
      <DialogContent
        classes={{
          root: classes.content
        }}
      >
        <img src={RfqRequestDialogImg} alt="img" />
        <CustomizedTypography
          variant={matches ? 'h3' : 'h2'}
          color="textPrimary"
          fontWeight="bold"
          gutterBottoms={8}
        >
          견적요청이 필요하신가요?
        </CustomizedTypography>
        <CustomizedTypography
          variant="body1"
          color="textPrimary"
          gutterBottoms={matches ? 48 : 64}
        >
          견적요청을 위해선 로그인이 필요합니다.
        </CustomizedTypography>
      </DialogContent>
      <DialogActions classes={{ root: classes.dialogAction }}>
        <CustomizedButton
          variant="outlined"
          color="primary"
          size="large"
          fullWidth
          onClick={() => {
            onClick('/signup');
          }}
        >
          회원가입 하기
        </CustomizedButton>
        <CustomizedButton
          variant="contained"
          color="primary"
          size="large"
          fullWidth
          onClick={() => {
            onClick('/login');
          }}
        >
          로그인 하기
        </CustomizedButton>
      </DialogActions>
    </Dialog>
  );
};

export default RfqRequestDialogPresenter;
